import React from 'react';
import { Outlet } from 'react-router-dom';
import AgroSidebar from './AgroSidebar';
import Header from '../Header/Header';
import containerStyles from './container.module.css';

const AgroLayout: React.FC = () => {
  return (
    <>
      <style>{`
        /* ── Desktop ─────────────────────────────────────────── */
        .agro-content-wrap {
          flex: 1;
          display: flex;
          flex-direction: column;
          margin-left: 72px;
          height: 100vh;
          overflow: hidden;
        }
        .agro-page-wrap {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
        }

        /* ── Mobile ──────────────────────────────────────────── */
        @media (max-width: 768px) {
          .agro-content-wrap {
            margin-left: 0 !important;
          }
          /* Desconta a altura da bottom nav (60px) do espaço disponível */
          .agro-page-wrap {
            padding-bottom: 0 !important;
            height: calc(100vh - 60px) !important;
            /* subtrai também o header — ajuste se o header tiver altura diferente */
          }
        }
      `}</style>

      {/*
        O container raiz ocupa exatamente 100vh sem scroll.
        Todo o scroll acontece dentro de .agro-page-wrap.
        A bottom nav é fixed, então não participa do flow.
      */}
      <div style={{
        display: 'flex',
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',   /* impede que NADA extravase e mude o tamanho */
      }}>
        <AgroSidebar />

        <div className="agro-content-wrap">
          <Header />
          <main
            className={`${containerStyles.containerPage} agro-page-wrap`}
            style={{ paddingLeft: 0 }}
          >
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
};

export default AgroLayout;